import * as React from 'react';

import Form from '../Form/Form';

const LoginForm = ({ handleLogin, buttonText = 'Login', disabled = false }) => (
  <Form
    type="login"
    fields={[
      {
        name: 'email',
        label: 'Email',
        type: 'email',
      },
      {
        name: 'password',
        label: 'Password',
        type: 'password',
      },
    ]}
    handleSubmit={handleLogin}
    buttonText={buttonText}
    disabled={disabled}
  />
);

export default LoginForm;
